import React, { Fragment } from "react";
import { withResizeDetector } from "react-resize-detector";

// APP's Routes
import RoutesAuth from "./routes";
import { BrowserRouter as Router } from "react-router-dom";

/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

const App = ({ width }) => {
  const body = document.querySelector("body");
  body.setAttribute("data-typography", "roboto");
  body.setAttribute("data-theme-version", "light");
  body.setAttribute("data-layout", "vertical");
  body.setAttribute("data-nav-headerbg", "color_1");
  body.setAttribute("data-headerbg", "color_1");
  body.setAttribute("data-sidebar-style", "overlay");
  body.setAttribute("data-sibebarbg", "color_1");
  body.setAttribute("data-primary", "color_1");
  body.setAttribute("data-sidebar-position", "fixed");
  body.setAttribute("data-header-position", "fixed");
  body.setAttribute("data-container", "wide");
  body.setAttribute("direction", "ltr");
  body.setAttribute("class","h-100");


  //ADDED TO CENTER LOGIN PAGES
  const root = document.querySelector("#root");
  root.setAttribute("class","h-100");
  const html = document.querySelector("html");
  html.setAttribute("class","h-100");
  //END ADDED TO CENTER LOGIN PAGES

  width >= 768 && width < 1300
    ? body.setAttribute("data-sidebar-style", "mini")
    : width <= 768
    ? body.setAttribute("data-sidebar-style", "overlay")
    : body.setAttribute("data-sidebar-style", "full");

  return (
    <Fragment>
      <Router basename="">
        <RoutesAuth />
      </Router>
    </Fragment>
  );
};

export default withResizeDetector(App);
